import { CustomAddress } from '@core/const';

export class OccShopConverter {
  protected addressFormattedNormalize(address: CustomAddress): string {
    const addressArray = [address.streetname];

    if (address.streetnumber !== '0') {
      addressArray.push(address.streetnumber);
    }
    addressArray.push(address.town);

    return addressArray.filter(Boolean).join(', ');
  }
}
